import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { Tooltip } from 'antd';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';

//import AdminTitleBar from 'Parts/common/AdminTitleBar';
import SearchBar from 'Parts/search/SearchBarContainer';
import PaginationTop from 'Parts/search/PaginationTop';
import ResultTable from 'Parts/search/ResultTable';
import Can from 'Parts/session/components/CanContainer';
import { simpleColumn, dateColumn, validationColumn, actionsColumn } from 'Parts/common/columnUtils';
import { DEFAULT_PAGER } from 'Parts/search/searchUtils';
import FundkyButton from 'Parts/ui/components/FundkyButton';
import CsvReportButton from '../../../../../report/components/CsvReportButtonContainer';
import { getLanguages, getLanguageNameByKey } from 'Parts/common/langUtils'

import EventAdminAttendeesCheckinPage_en from './locales/EventAdminAttendeesCheckinPage_en.json';
import EventAdminAttendeesCheckinPage_fr from './locales/EventAdminAttendeesCheckinPage_fr.json';

class EventAdminAttendeesCheckinPage extends React.Component {
  constructor(props) {
    super(props);

    // PARAMS
    // filterBy =
    // orderBy = addedOn || attendedOn ([asc] | [desc])
    // showDescription = true
    // showAdvantage = true

    props.fetchPurchasedTicketList(
      props.campaign.id,
      { // PARAMS
        orderBy: 'addedOn[desc]',
        pageResults: 10
      },
      true
    );

    this.state = {
      pager: {
        ...DEFAULT_PAGER,
        total: props.pagination.totalResults || 0,
        current: props.pagination.pageNumber || 1,
        pageSize: props.pagination.pageResults || 10
      }
    };

    i18next.addResourceBundle('en', 'EventAdminAttendeesCheckinPage', EventAdminAttendeesCheckinPage_en);
    i18next.addResourceBundle('fr', 'EventAdminAttendeesCheckinPage', EventAdminAttendeesCheckinPage_fr);
  }

  componentDidUpdate(prevProps) {
    // Update the pager with the new total
    let pager;

    if (this.props.pagination.pageNumber !== prevProps.pagination.pageNumber) {
      pager = {
        ...this.state.pager,
        total: this.props.pagination.totalResults || 0,
        current: this.props.pagination.pageNumber || 1,
        pageSize: this.props.pagination.pageResults || 10
      };

      this.setState({ pager });
    }
  }

  componentWillUnmount() {
    this.props.clearPurchasedTicketList();
  }

  handlePaginationChange = pager => {
    this.setState({ pager });

    this.props.fetchPurchasedTicketList(
      this.props.campaign.id,
      {// PARAMS
        orderBy: 'addedOn[desc]',
        pageResults: pager.pageSize,
        pageNumber: pager.current,
        ... this.props.search
          ? { search: this.props.search }
          : {},
        // filterBy: {}
      },
      true
    );
  };

  handleSearch = filters => {
    this.props.fetchPurchasedTicketList(
      this.props.campaign.id,
      {// PARAMS
        orderBy: 'addedOn[desc]',
        pageResults: this.state.pager.pageSize,
        pageNumber: 1,
        ... filters.search
          ? { search: filters.search }
          : {},
        // filterBy: filters
      },
      true
    );
  };

  handleValidate = ticketId => {
    this.props.attendEvent(this.props.campaign.id, ticketId)
      .then(() => {
        const { pager } = this.state;

        this.props.fetchPurchasedTicketList(
          this.props.campaign.id,
          {// PARAMS
            orderBy: 'addedOn[desc]',
            pageResults: pager.pageSize,
            pageNumber: pager.current,
            ... this.props.search
              ? { search: this.props.search }
              : {},
            // filterBy: {}
          },
          true
        );
      })
      .catch(error => {
        console.error("validation error", error)
      })
  };

  render() {
    const { t, platform, campaign, tickets, pagination, locale, isAttendEventInProgress, history, isCampaignOwner, reportAttendeesInEvent } = this.props;
    const { pager } = this.state;

    const CsvReportButtonDisabled = !tickets || tickets.length == 0;
    const tooltipVisibility = !CsvReportButtonDisabled ? { visible: false } : {};



    return (
      <div className="EventAdminAttendeesCheckinPage">
        <Helmet>
          <title>{t('checkin')}</title>
        </Helmet>
        <SearchBar
          title={t('checkin')}
          subName={t('title-notice')}
          placeholder={t('search')}
          onSearch={this.handleSearch}
          reportButton={
            <Tooltip title={t('no-transaction')} {...tooltipVisibility}>
              <div>
                <CsvReportButton
                  key={1}
                  data={this.props.report}
                  id={this.props.campaign.id}
                  pagination={this.props.pagination}
                  orderBy={{ orderBy: 'addedOn[desc]' }}
                  filters={this.props.filters}
                  fileName={`${this.props.platform.alias}.${this.props.campaign.alias}.transactions`}
                  fetch={reportAttendeesInEvent}
                  disabled={CsvReportButtonDisabled ? true : null}
                />
              </div>
            </Tooltip>
          }
        />
        <Can
          rules={[
            [() => isCampaignOwner ? true : false],
            ['roles.platform.OWNER'],
            ['roles.platform.SUPERADMIN'],
            ['roles.campaign.OWNER']
          ]}
          redirect={`/${locale}/d`}
        >
          <div className="AdminList">
            <PaginationTop
              totalLabel={total => t('tickets-total', { count: pagination.totalResults })}
              pager={pager}
              onChange={this.handlePaginationChange}
            />
            <ResultTable
              dataSource={tickets}
              pagination={pager}
              onChange={this.handlePaginationChange}
              showHeader={true}
              columns={[
                simpleColumn(t("ticket"), 'ticketNumber', null, true),
                //simpleColumn(t("transaction-number"), 'referenceId', null, true),
                simpleColumn(t("buyers-name"), 'buyer.name', null, true),
                //dateColumn(t('transaction-date'), 'addedOn', null, null, false, locale),
                simpleColumn(t('attendee'), null, ticket => `${ticket.firstName} ${ticket.lastName}${ticket.username ? ` (${ticket.username})` : ''}`, true),
                simpleColumn(t('ticket-name'), null, ticket => {
                  let lang = getLanguageNameByKey(locale, false);
                  if (get(ticket, 'ticket.description.' + lang + '.name')){
                    return ticket.ticket.description[lang].name;
                  } else {
                    let languages = getLanguages();
                    for (let language of languages) {
                      if (get(ticket, 'ticket.description.' + language.name.toLowerCase() + '.name')) {
                        return ticket.ticket.description[language.name.toLowerCase()].name;
                      }
                    }
                    return "";
                  }
                }, true),
                validationColumn(
                  t('validate-on'),
                  'attendedOn',
                  ticket => {
                    return (
                      <FundkyButton
                        className="ant-btn"
                        text={t('validate')}
                        onClick={() => this.handleValidate(ticket.id)}
                        size="large"
                        loading={isAttendEventInProgress}
                      />
                    );
                  },
                  null,
                  false,
                  locale
                ),
                actionsColumn(
                  "",
                  [
                    {
                      icon: ['fal', 'edit'],
                      function: ticket => history.push(`/${locale}/d/campaigns/${campaign.id}/attendees/${ticket.id}`)
                    },
                    // {
                    //   icon: ['fal', 'download'],
                    //   function: () => console.log('download')
                    // }
                  ]
                ),
              ]}
            />
          </div>
        </Can>
      </div>
    );
  }
}

EventAdminAttendeesCheckinPage.defaultProps = {

};

export default translate('EventAdminAttendeesCheckinPage')(EventAdminAttendeesCheckinPage);
